import React from 'react'
import { map } from 'lodash'
import {
  NavLink,
} from "react-router-dom"

import { displayFullHours } from '../helpers/officeHours'
import { displayPhone, generateUrl, generateAddress, generateFax, generatePhone } from '../helpers/clinic'
import SocialIcons from './SocialIcons'

export default ({data, clinic}) => {
  const FooterLocation = ({ecs_clinic}) => {
    return <div className="">
      <h3 className="font-semibold text-sm uppercase tracking-[2px]">{ecs_clinic.name}</h3>
      <div className="text-xs md:text-sm mb-2">
        {generateAddress(ecs_clinic)}
      </div>
      <div className="mb-2">
        tel: { generatePhone(ecs_clinic.phone) }
      </div>
      <div className="mb-2">
        fax: { generateFax(ecs_clinic.fax) }
      </div>
      <div className="mb-4 text-xs">
        { displayFullHours(ecs_clinic)}
      </div>
      <div className="mb-2 flex flex-start gap-2">
        <SocialIcons clinic={ecs_clinic} classes="w-6 h-6" />
      </div>
    </div>
  }

  const thisYear = new Date().getFullYear()

  // const homeLink = generateUrl(clinic, '')
  // const aboutLink = generateUrl(clinic, 'about')
  // const servicesLink = generateUrl(clinic, 'services')
  // const contactLink = generateUrl(clinic, 'contact')

  const SectionLink = ({label, url}) => {
    const _url = generateUrl(clinic, url)
    return <NavLink to={_url} className="text-xs uppercase hover:underline">{label}</NavLink>
  }

  return (
    <footer className="bg-gradient-to-b from-sky-400 to-sky-700 py-24 text-white text-sm min-h-screen">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-wrap gap-6 md:gap-8 mb-8 pb-8 border-b border-white/25">
          <SectionLink label="Home" url={''} />
          <SectionLink label="About" url={'about'} />
          <SectionLink label="Services" url={'services'} />
          <SectionLink label="Appointments" url={'appointments'} />
          <SectionLink label="Contact" url={'contact'} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 pb-8 border-b border-white/25 mb-8">
        {
          map(data.clinics, (c, index) => {
            return <FooterLocation ecs_clinic={c} key={`footer-clinic-${index}`} />
            
          })
        }
        </div>
        <div className="text-center text-xs md:text-sm text-white/50">
          Copyright &copy; {thisYear} Eye Clinics of Seattle. All Rights Reserved
        </div>
      </div>
    </footer>
  )
}